export const SET_WELCOME_APPLY_BONUS = 'SET_WELCOME_APPLY_BONUS';
export const SET_WELCOME_BANNER_OPENED = 'SET_WELCOME_BANNER_OPENED';

export const CLEAR_BONUSES = 'CLEAR_BONUSES';

export const BONUSES_SET_ACTIVE_START = 'BONUSES_SET_ACTIVE_START';
export const BONUSES_SET_ACTIVE_SUCCESS = 'BONUSES_SET_ACTIVE_SUCCESS';
export const BONUSES_SET_ACTIVE_FAILURE = 'BONUSES_SET_ACTIVE_FAILURE';

export const BONUSES_SET_AVAILABLE = 'BONUSES_SET_AVAILABLE';

export const GET_NEW_LIFE_ACCOUNTS_START = 'GET_NEW_LIFE_ACCOUNTS_START';
export const GET_NEW_LIFE_ACCOUNTS_SUCCESS = 'GET_NEW_LIFE_ACCOUNTS_SUCCESS';
export const GET_NEW_LIFE_ACCOUNTS_FAILURE = 'GET_NEW_LIFE_ACCOUNTS_FAILURE';

export const SET_NEW_LIFE_RESPAWN_START = 'SET_NEW_LIFE_RESPAWN_START';
export const SET_NEW_LIFE_RESPAWN_SUCCESS = 'SET_NEW_LIFE_RESPAWN_SUCCESS';
export const SET_NEW_LIFE_RESPAWN_FAILURE = 'SET_NEW_LIFE_RESPAWN_FAILURE';

export const SET_NEW_LIFE_RESPAWN_BANNER_OPENED = 'SET_NEW_LIFE_RESPAWN_BANNER_OPENED';

export const BONUS_NAMES = {
    WELCOME: 'welcome',
    GIFT50: 'gift_50',
    NEW_LIFE: 'new_life',
}

export const BONUS_STATUSES = {
    ACTIVE: 'active',
    CANCELED: 'canceled',
    DECLINED: 'declined',
    NOT_APPLICABLE: 'not_applicable',
    PROCESSING: 'processing',
    WAITING: 'waiting',
    WAGERED: 'wagered',
    WITHDRAWN: 'withdrawn'
}
